import { PropTypes } from 'prop-types';
import { useQuery } from 'react-query';
import { getSearchAPIKey, getSearchAPIKeyUrl } from '@general/api/searchKeyAPI';

const useSearchAPIKey = ({ isAttendeeSearch = false, eventCode, memberID }) => {
    const url = getSearchAPIKeyUrl({ isAttendeeSearch, eventCode, memberID });

    // TODO cache for life of token
    return useQuery(url, getSearchAPIKey({ isAttendeeSearch, eventCode, memberID }), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
};

useSearchAPIKey.propTypes = {
    isAttendeeSearch: PropTypes.bool,
    eventCode: PropTypes.string,
    memberID: PropTypes.number,
};

export default useSearchAPIKey;
